import React from "react";
import { Stack, Typography } from "@mui/material";
import { connect } from "react-redux";

import { IndustriesTable } from "../../tables";
import { IndustryDialog } from "../../dialogs";
import { HubButton, HubHookFormWrapper, PageContent } from "../../components";
import { useGetAllIndustryData } from "../../hooks";
import { setIsOpenDialog } from "../../redux";

const MiscContainer = ({ _setIsOpenDialog = () => {} }) => {
  const { data } = useGetAllIndustryData();
  
  const handleCreateClick = () => {
    _setIsOpenDialog("edit-industry", true);
  };
  
  return (
    <HubHookFormWrapper onSubmit={() => {}} sx={{ width: "100%", padding: "20px" }}>
      <Stack gap="40px">
        <PageContent gap="10px" smallPadding hideOverflow sx={{ width: "100%", maxWidth: "500px", height: "700px" }}>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">Industries</Typography>
            <HubButton
              label="Create Industry"
              variant="contained"
              size="xsmall"
              onClick={handleCreateClick}
            />
          </Stack>
          <IndustriesTable />
          <IndustryDialog allIndustries={data?.rows} />
        </PageContent>
        {/* Future misc components will go here */}
      </Stack>
    </HubHookFormWrapper>
  );
};

const mapDispatchToProps = {
  _setIsOpenDialog: setIsOpenDialog,
};

const ConnectedMiscContainer = connect(null, mapDispatchToProps)(MiscContainer);

export { ConnectedMiscContainer as MiscContainer };
export default ConnectedMiscContainer;